module.exports = __webpack_public_path__ + "img/31d0e8a594188c5912635e8f0096aa9d.png";